import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from 'app/services/app/app.service';

@Pipe({
  name: 'traduccion'
})
export class TraduccionPipePipe implements PipeTransform {

  constructor(private appService: AppService) {}


  transform(value: any, propertyOrParams?: any, params?: Record<string, any>): any {

    if(value == undefined){
      return propertyOrParams;
    }

    if(value.literals != undefined){
      return this.appService.getLiteralTraduccion(value, propertyOrParams);
    }

    const translationParams = propertyOrParams && typeof propertyOrParams === 'object' && !Array.isArray(propertyOrParams)
      ? propertyOrParams
      : params;

    return this.appService.getTraduccion(value, translationParams);
  }

}